module.exports = __webpack_public_path__ + "static/media/HOME-image8.bf1a465a.png";